import { render, staticRenderFns } from "./pwa_logo.vue?vue&type=template&id=42ec75fb&scoped=true&"
import script from "./pwa_logo.vue?vue&type=script&lang=js&"
export * from "./pwa_logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec75fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42ec75fb')) {
      api.createRecord('42ec75fb', component.options)
    } else {
      api.reload('42ec75fb', component.options)
    }
    module.hot.accept("./pwa_logo.vue?vue&type=template&id=42ec75fb&scoped=true&", function () {
      api.rerender('42ec75fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/images/pwa_logo.vue"
export default component.exports